var render, staticRenderFns
import script from "./SurveyCategory.vue?vue&type=script&lang=js&"
export * from "./SurveyCategory.vue?vue&type=script&lang=js&"
import style0 from "./SurveyCategory.vue?vue&type=style&index=0&id=3436dc06&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports